import React from "react";
import './StockMessage.css';

const StockMessage = ({ stock }) => {
  let message = "";

  if (stock === 0) {
    message = "Out of stock";
  } else if (stock <= 3) {
    message = `Hurry! Only ${stock} left in stock!`;
  } else if (stock <= 5) {
    message = `Only ${stock} left – order soon!`;
  } else if (stock <= 10) {
    message = "Limited stock available!";
  }

  return (
    <div className="stock-message">
      {message && <p>{message}</p>}
    </div>
  );
};

export default StockMessage;